
import EventCardGeneral from '@/components/EventCardGeneral.vue';
import ShimmerEffect from "@/components/ShimmerEffect.vue";
import moment from "moment";
export default {
  components: {
    EventCardGeneral,
    ShimmerEffect
  },
  head() {
    return {
      title: this.title,
      meta: [{
        hid: "description",
        name: "description",
        content: this.description,
      },
      {
        hid: "keywords",
        name: "keywords",
        content: "Events in goa, events in goa today, upcoming events in goa, events in goa this weekend, events in goa this week, music events in goa today, party events in goa today, party events in goa, events in goa tomorrow",
      },
      {
        hid: "og:title",
        property: "og:title",
        content: this.title,
      },
      {
        hid: "og:description",
        property: "og:description",
        content: this.description,
      },
      {
        hid: "twitter:title",
        property: "twitter:title",
        content: this.title,
      },
      {
        hid: "twitter:description",
        property: "twitter:description",
        content: this.description,
      },
      { hid: 'og:image:alt',
        property: 'og:image:alt',
        content: this.title ? this.title : 'Goa App'
      },
      { hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/meta-imgs/events-meta-image.webp'
      },
      { hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/meta-imgs/events-meta-image.webp'
      },
      { hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/meta-imgs/events-meta-image.webp'
      },

      ],
      bodyAttrs: {
        class: this.showHelpModal ? 'pass-modal-open' : ''
      }
    };

  },
  data() {
    return {
      title: "Events in Goa - Events in Goa Today | Upcoming Events in Goa",
      description: "Events in goa - Explore all Today and Upcoming events in Goa. Music, art, nightlife, & more. Find your perfect event and secure your spot today. Book Now!",
      categoriesData: null,
      skip: 0,
      page: 1,
      totalNumberOfpages: 0,
      busy: false,
      productObj: [],
      listings: {},
      schemaData: [],
      loading: true,
      listingLoading: true,
      eventCategoryModal: false,

      //New code
      activiteStatesList: [],
      popularEvents: null,
      popularEventsLoading: true,
      bestEventsLoading: true,
      bestEvents: null,
      categoriesLoading: true,

      typeValue: "",
      displayTextArray: ["GOA", "BENGALURU", "PUNE", "MUMBAI"],
      eventDropDown: ['today', 'tomorrow', 'weekend' ],
      typingSpeed: 100,
      erasingSpeed: 100,
      newTextDelay: 2000,
      displayTextArrayIndex: 0,
      charIndex: 0,
      interLinks:  {
        "title": "Explore More on Goa App",
        "links": [
          {"sub_title":"More Events in Goa",
          "interLinks":[
	        {
            "name":"Comedy Shows",
            "url":"/events/comedy-events"
          },
          {
            "name":"Music Shows",
            "url":"/events/music-events"
          },
          {
            "name":"Religious Events",
            "url":"/events/religious-events"
          },
          {
            "name":"Food Events",
            "url":"/events/food-events"
          },
          {
            "name":"WorkShops",
            "url":"/events/workshop-events"
          },
          {
            "name":"Theatre Events",
            "url":"/events/theatre-events"
          },
          {
            "name":"Games",
            "url":"/events/games-events"
          },
          {
            "name":"Kids Events",
            "url":"/events/kids-events"
          },
          {
            "name":"Dance Shows",
            "url":"/events/dance-events"
          },
          {
            "name":"Poetry Events",
            "url":"/events/poetry-events"
          },
          {
            "name":"Party Events",
            "url":"/events/party-events"
          }

          ]},
          {"sub_title":"Events in Top Cities in India",
          "interLinks":[{
            "name":"Events in Bangalore",
            "url":"/bangalore/events/"
          },
          {
            "name":"Events in Delhi",
            "url":"/delhi/events/"
          },
          {
            "name":"Events in Goa",
            "url":"/goa/events/"
          },
          {
            "name":"Events in Hyderabad",
            "url":"/hyderabad/events/"
          },
          {
            "name":"Events in Mumbai",
            "url":"/mumbai/events/"
          },
          {
            "name":"Events in Pune",
            "url":"/pune/events/"
          }

          ]},
	       {"sub_title":"Mark Your Calendar",
          "interLinks":[{
            "name":"Events Happening Today",
            "url":"/events-today/"
          },
          {
            "name":"Events Happening Tomorrow",
            "url":"/events-tomorrow/"
          },
          {
            "name":"Events Happening this weekend",
            "url":"/events-weekend/"
          },
          {
            "name":"Events Today in Goa",
            "url":"/goa/events-today/"
          },
          {
            "name":"Events Tomorrow in Goa",
            "url":"/goa/events-tomorrow/"
          },
          {
            "name":"Events this weekend in Goa",
            "url":"/goa/events-weekend/"
          },
          {
            "name":"Events Today in Pune",
            "url":"/pune/events-today/"
          },
          {
            "name":"Events Tomorrow in Pune",
            "url":"/pune/events-tomorrow/"
          },
          {
            "name":"Events this weekend in Pune",
            "url":"/pune/events-weekend/"
          },
          {
            "name":"Events Today in Bangalore",
            "url":"/bangalore/events-today/"
          },
          {
            "name":"Events Tomorrow in Bangalore",
            "url":"/bangalore/events-tomorrow/"
          },
          {
            "name":"Events this weekend in Bangalore",
            "url":"/bangalore/events-weekend/"
          },
          {
            "name":"Events Today in Mumbai",
            "url":"/mumbai/events-today/"
          },
          {
            "name":"Events Tomorrow in Mumbai",
            "url":"/mumbai/events-tomorrow/"
          },
          {
            "name":"Events this weekend in Mumbai",
            "url":"/mumbai/events-weekend/"
          },


          ]},
          
          
             {"sub_title":"Events In Mumbai",
          "interLinks":[{
            "name":"Comedy Shows In Mumbai",
            "url":"/mumbai/events/comedy-events"
          },
         
          {
            "name":"Concerts In Mumbai",
            "url":"/mumbai/events/music-events"
          },        
        
         
           {
            "name":"Workshops In Mumbai",
            "url":"/mumbai/events/workshop-events"
          },
       
      
          {
            "name":"Cultural Events In Mumbai",
            "url":"/mumbai/events/cultural-events"
          },
          {
            "name":"Food Events In Mumbai",
            "url":"/mumbai/events/food-events"
          },
       
        
            {
            "name":"Social Events In Mumbai",
            "url":"/mumbai/events/social-events"
          },
            {
            "name":"Religious Events In Mumbai",
            "url":"/mumbai/events/religious-events"
          },
            {
            "name":"Automative Events In Mumbai",
            "url":"/mumbai/events/automotive-events"
          },
            {
            "name":"Courses In Mumbai",
            "url":"/mumbai/events/courses-events"
          },
            {
            "name":"Theatre In Mumbai",
            "url":"/mumbai/events/theatre-events"
          },
            {
            "name":"Health Events In Mumbai",
            "url":"/mumbai/events/health-events"
          },
            {
            "name":"Games In Mumbai",
            "url":"/mumbai/events/games-events"
          },
            {
            "name":"Events For Kids In Mumbai",
            "url":"/mumbai/events/kids-events"
          },
            {
            "name":"Talks In Mumbai",
            "url":"/mumbai/events/talks-events"
          },
            {
            "name":"Adventure In Mumbai",
            "url":"/mumbai/events/adventure-events"
          },
            {
            "name":"Dance Performances In Mumbai",
            "url":"/mumbai/events/dance-events"
          },
            {
            "name":"Documentary Events In Mumbai",
            "url":"/mumbai/events/documentary-events"
          },
            {
            "name":"Poetry Events In Mumbai",
            "url":"/mumbai/events/poetry-events"
          },

          {
            "name":"Parties In Mumbai",
            "url":"/mumbai/events/party-events"
          },

         {
            "name":"Trekking In Mumbai",
            "url":"/mumbai/events/trekking-events"
          },

          ]},
          
          
          
          
           {"sub_title":"Events In Bangalore",
          "interLinks":[{
            "name":"Standup Comedy In Bangalore",
            "url":"/bangalore/events/comedy-events"
          },
         
          {
            "name":"Concerts In Bangalore",
            "url":"/bangalore/events/music-events"
          },        
        
         
           {
            "name":"Workshops In Bangalore",
            "url":"/bangalore/events/workshop-events"
          },
       
      
          {
            "name":"Cultural Events In Bangalore",
            "url":"/bangalore/events/cultural-events"
          },
          {
            "name":"Food Events in Bangalore",
            "url":"/bangalore/events/food-events"
          },
       
        
            {
            "name":"Social Events In Bangalore",
            "url":"/bangalore/events/social-events"
          },
            {
            "name":"Religious Events In Bangalore",
            "url":"/bangalore/events/religious-events"
          },
            {
            "name":"Automative Events In Bangalore",
            "url":"/bangalore/events/automotive-events"
          },
            {
            "name":"Courses In Bangalore",
            "url":"/bangalore/events/courses-events"
          },
            {
            "name":"Theatre In Bangalore",
            "url":"/bangalore/events/theatre-events"
          },
            {
            "name":"Health Events In Bangalore",
            "url":"/bangalore/events/health-events"
          },
            {
            "name":"Games In Bangalore",
            "url":"/bangalore/events/games-events"
          },
            {
            "name":"Events For Kids In Bangalore",
            "url":"/bangalore/events/kids-events"
          },
            {
            "name":"Talks In Bangalore",
            "url":"/bangalore/events/talks-events"
          },
            {
            "name":"Adventure In Bangalore",
            "url":"/bangalore/events/adventure-events"
          },
            {
            "name":"Dance Performances In Bangalore",
            "url":"/bangalore/events/dance-events"
          },
            {
            "name":"Documentary Events In Bangalore",
            "url":"/bangalore/events/documentary-events"
          },
            {
            "name":"Poetry Events In Bangalore",
            "url":"/bangalore/events/poetry-events"
          },

          {
            "name":"Parties In Bangalore",
            "url":"/bangalore/events/party-events"
          },

         {
            "name":"Trekking In Bangalore",
            "url":"/bangalore/events/trekking-events"
          },

          ]},

          
             {"sub_title":"Events In Pune",
          "interLinks":[{
            "name":"Standup Comedy In Pune",
            "url":"/pune/events/comedy-events"
          },
         
          {
            "name":"Concerts In Pune",
            "url":"/pune/events/music-events"
          },        
        
         
           {
            "name":"Workshops In Pune",
            "url":"/pune/events/workshop-events"
          },
       
      
          {
            "name":"Cultural Events In Pune",
            "url":"/pune/events/cultural-events"
          },
          {
            "name":"Food Events In Pune",
            "url":"/pune/events/food-events"
          },
       
        
            {
            "name":"Social Events In Pune",
            "url":"/pune/events/social-events"
          },
            {
            "name":"Religious Events In Pune",
            "url":"/pune/events/religious-events"
          },
            {
            "name":"Automative Events In Pune",
            "url":"/pune/events/automotive-events"
          },
            {
            "name":"Courses In Pune",
            "url":"/pune/events/courses-events"
          },
            {
            "name":"Theatre In Pune",
            "url":"/pune/events/theatre-events"
          },
            {
            "name":"Health Events In Pune",
            "url":"/pune/events/health-events"
          },
            {
            "name":"Games In Pune",
            "url":"/pune/events/games-events"
          },
            {
            "name":"Events For Kids In Pune",
            "url":"/pune/events/kids-events"
          },
            {
            "name":"Talks In Pune",
            "url":"/pune/events/talks-events"
          },
            {
            "name":"Adventure In Pune",
            "url":"/pune/events/adventure-events"
          },
            {
            "name":"Dance Performances In Pune",
            "url":"/pune/events/dance-events"
          },
            {
            "name":"Documentary Events In Pune",
            "url":"/pune/events/documentary-events"
          },
            {
            "name":"Poetry Events In Pune",
            "url":"/pune/events/poetry-events"
          },

          {
            "name":"Parties In Pune",
            "url":"/pune/events/party-events"
          },

         {
            "name":"Trekking In Pune",
            "url":"/pune/events/trekking-events"
          },

          ]},
        ]
      }
    }
  },

  created() {
    setTimeout(this.typeText, this.newTextDelay + 200);
  },

  mounted() {
    this.getData();
    let pagination = (this.page - 1) * 8;
    if (pagination < 0) {
      pagination = 0;
    }
    this.getListings(pagination);
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  methods: {
    async getData() {
      this.categoriesData = await fetch(this.$config.fetchUrl + '/api/activityTypes/app/getTypeDetails/events/')
        .then(res => res.text());
      this.categoriesData = this.getCryptKey(this.categoriesData);
      this.categoriesLoading = false;
      this.activiteStatesList = await fetch(this.$config.fetchUrl + '/api/states/app/getAllActiveStates/')
        .then(res => res.text());
      this.activiteStatesList = this.getCryptKey(this.activiteStatesList);
      this.popularEvents = await fetch(this.$config.fetchUrl + '/api/events/getFeaturedEvents/')
        .then(res => res.text());
      this.popularEvents = this.getCryptKey(this.popularEvents);
      this.popularEventsLoading = false
      this.bestEvents = await fetch(this.$config.fetchUrl + '/api/events/getPopularEvents/')
        .then(res => res.text());
      this.bestEvents = this.getCryptKey(this.bestEvents);
      this.bestEventsLoading = false
    },

    cityDropdownClicked(event) {
      if (event && event.target.value) {
        this.$router.push({
          path: `/${event.target.value}/events/`
        })
      }
    },
    categoryBtnClicked(item) {
      if (item && item.slug) {
        this.$router.push({
          path: `/events/${item.slug}-events`
        })
      }
    },

    eventDay(day) {
      switch (day) {
        case 'today':
          this.$router.push({
            path: `/events-today`
          })
          break;
        case 'tomorrow':
          this.$router.push({
            path: `/events-tomorrow`
          })
          break;
        case 'weekend':
          this.$router.push({
            path: `/events-weekend`
          })
          break;
        default:
          this.$router.push({
            path: `/events-today`
          })
          break;
      }
    },

    loadMore() {
      this.busy = false;
      if (this.listings.isMoreDataAvailable) {
        this.busy = true;
        setTimeout(() => {
          this.page++
          this.callback(this.page)
        }, 1000);
      }
    },

    // callback for the pagination plugin
    callback: function (page) {
      this.page = page;
      let pagination = (page - 1) * 8;
      if (pagination < 0) {
        pagination = 0;
      }
      this.getListings(pagination);
    },

    // TO get SUBSCRIPTIONS using pagination
    getListings(skip, year = null, month = null, categories = null, queryStr = null) {
      //if no categories are selected we can mkae a get request of the form /api/posts/app/getPostsOfType/places/:query/:pagination/:categories/:sortBy
      //the reason is POST requests cant be cached but get requests can so the data will load very fast when user hits back from a detail page
      //this.listingLoading = true;

      // AXIOS api call to add review api
      this.$axios
        .get(
          `/api/events/getAllUpcomingEvents/${skip}`
        )
        .then((response) => {
          let value = this.getCryptKey(response.data);
          this.productObj.push(...value.events)
          this.listings = value;
          this.schemaData = this.listings && this.listings.events ? this.listings.events : [];
          if (skip == 0) {
            this.page = 1;

          }
          this.totalNumberOfpages = Math.ceil(this.listings.totalCount / 12);
          this.$nextTick(() => {
            this.busy = false;
            this.listingLoading = false;
          });
        })
        .catch((error) => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        })
        .finally(() => {
          this.$nextTick(() => {
            this.listingLoading = false;
          });
        });
    },
    typeText() {
      if (this.charIndex < this.displayTextArray[this.displayTextArrayIndex].length) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue += this.displayTextArray[this.displayTextArrayIndex].charAt(
          this.charIndex
        );
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue = this.displayTextArray[this.displayTextArrayIndex].substring(
          0,
          this.charIndex - 1
        );
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.displayTextArrayIndex += 1;
        if (this.displayTextArrayIndex >= this.displayTextArray.length)
          this.displayTextArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    }

  }

}
